var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-image" },
    [
      _c("image-displayer", {
        attrs: {
          cdn_path: _vm.localCdnPath,
          image_path: _vm.localImagePath,
          btnClicked: _vm.btnClicked,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "up-buttons" }, [
        _c(
          "div",
          [
            !_vm.hideDelete
              ? [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.confirm-modal",
                          modifiers: { "confirm-modal": true },
                        },
                      ],
                      staticClass: "flex f-center f-j-center",
                      attrs: { variant: "danger" },
                      on: { click: _vm.deleteImage },
                    },
                    [_c("span", { staticClass: "icon-delete" })]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2" },
              [
                _c("input", {
                  staticClass: "custom-file-input js-file-input__field",
                  attrs: { id: "inputfile", type: "file", name: "attachment" },
                  on: { change: _vm.fileChangeHandler },
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn-img flex f-center f-j-center" },
                  [_c("span", { staticClass: "icon-plus" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-img flex f-center f-j-center mt-2",
                on: { click: _vm.openImage },
              },
              [_c("span", { staticClass: "icon-eye" })]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.fileUpdated
        ? _c("small", { staticClass: "filename" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm._f("truncate")(_vm._f("if_null")(_vm.theFileName), 40)
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }